import { observable } from 'mobx';
import { task, collated } from './helpers';
import ItemsAPI from 'api/items';

export class Search {
	@observable query = '';

	@task
	@collated
	search({ query = '' }) {
		this.query = query;

		return new ItemsAPI.fetchItems(query);
	}
}

export default new Search();



// WEBPACK FOOTER //
// ./src/state/Search.js